import styles from './style.module.css';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { newTaskConfig } from '../../recoil/atoms';

const SummaryItem = ({title,value,children})=>{
  return(
    <div className={styles["summary-item"]}>
      <span>{title}</span>
      <p>
        {value.map((item)=>(
          <span>{item}</span>
        ))}
      </p>
      {children}
    </div>   
  );
};

export default function NewTaskSummary({target}){
  const taskConfig = useRecoilValue(newTaskConfig);

  return(
  <div className={styles["body-summary"]}>
    <span>Task Preview</span>
    {/* <SummaryItem title="Task Name" value={[taskConfig.taskName]}/> */}
    { target.includes("data") && 
    <>
      <SummaryItem title="Required Data" value={[taskConfig.requiredData]}/>
      <SummaryItem title="Model" value={[taskConfig.initialModelName]}/>
    </>
    }
    { target.includes("device") && 
    <>
      <SummaryItem title="Device Filter" value={taskConfig.deviceQuery}></SummaryItem>
      {/* <SummaryItem title="Data Size" value={taskConfig.maxDataSize}></SummaryItem> */}
      {/* <SummaryItem title="Estimated Devices" value={taskConfig.estimatedDevices}></SummaryItem> */}
      {/* <SummaryItem 
      title="Device Request Per Round" 
      value={[`Training ${taskConfig.numOfTargetTrainingRequestDevicesPerRound}`,`Test ${taskConfig.numOfTargetTestRequestDevices}`]}
      />
      <SummaryItem 
      title="Device Response Per Round" 
      value={[`Training ${taskConfig.numOfTargetTrainingResponseDevicesPerRound}`, `Test ${taskConfig.numOfTargetTestResponseDevices}`]}
      /> */}
      <div className={styles["summary-item"]}>
        <span>Device Count Per Round</span>
        <div className={styles["item-count"]}>
          <div className={styles["item-count-row"]}>
            <span></span>
            <span>Training & Evaluation</span>
            <span>Test</span>
          </div>
          <div className={styles["item-count-row"]}>
            <span>Device Request</span>
            <span>{taskConfig.numOfTargetTrainingRequestDevicesPerRound}</span>
            <span>{taskConfig.numOfTargetTestRequestDevices}</span>
          </div>
          <div className={styles["item-count-row"]}>
            <span>Device Response</span>
            <span>{taskConfig.numOfTargetTrainingResponseDevicesPerRound}</span>
            <span>{taskConfig.numOfTargetTestResponseDevices}</span>
          </div>
        </div>
      </div>
      <SummaryItem title="Sampling Method" value={[taskConfig.samplingMethod]}/>
    </>
    }
    {/* <SummaryItem title="Aggregation Algorithm" value={[taskConfig.aggregationAlgorithm]}/>
    <SummaryItem 
    title="Rounds" 
    value={[`Round Num ${taskConfig.maxRound}`, `Timeout Per Round ${taskConfig.roundTimeout}`]}
    />
    <SummaryItem 
    title="Hyperparameters" 
    value={[`Epoch ${taskConfig.epoch}`, `Batch Size ${taskConfig.batchSize}`]}
    /> */}
  </div> 
  )
}